import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { styled } from "@mui/material/styles";
import {
  Box,
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  CircularProgress,
  Backdrop,
} from "@mui/material";

import api from "../services/api";
import { setLocalStorage } from "../utils/auth";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post("users/login", {
        email: email.toLowerCase(),
        password: password,
        loginUser: "Admin",
        // loginUser: "Super Admin",
      });

      if (response?.data?.success) {
        setLocalStorage("access", response?.data?.data?.access_token);
        setLocalStorage("refresh", response?.data?.data?.refresh_token);
        setLocalStorage("user", JSON.stringify(response?.data?.data));
        navigate("/dashboard");
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.error ?? "Error logging in, please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const StyledImage = styled("img")(({ theme }) => ({
    maxWidth: "100%",
    marginTop: "16px",
    height: "68px",

    [theme.breakpoints.up("md")]: {
      height: "74px",
    },
    [theme.breakpoints.up("lg")]: {
      height: "80px",
    },
  }));

  return (
    <>
      <div>
        <Box textAlign="center" mb={2}>
          <StyledImage
            src="./full-logo.png"
            alt="Bihar Board Examination"
            title="Bihar Board Examination"
          />
        </Box>
        <div style={{ height: "54px", backgroundColor: "#8C0001" }} />
        <Container maxWidth="sm">
          <Box textAlign="center" mb={1}>
            <img
              src="./star-horizontal-line.png"
              alt="Bihar Board Examination"
              title="Bihar Board Examination"
              style={{ maxWidth: "80%", height: "100%", textAlign: "center" }}
            />
          </Box>
          <Paper elevation={3} style={{ padding: "24px" }}>
            {/* Image Section */}
            {/* <Box textAlign="center" mb={2}>
              <img
                src="./logo.webp"
                alt="Bihar Board Examination"
                title="Bihar Board Examination"
                style={{ maxWidth: "100%", height: "150px" }}
              />
            </Box> */}

            {/* Header Section */}
            <Box textAlign="center" mb={2}>
              <Typography
                variant="h4"
                gutterBottom
                sx={{
                  fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.8rem" },
                }}
              >
                Super Admin Panel
              </Typography>
            </Box>

            <form onSubmit={handleSubmit}>
              <Box mb={2}>
                <TextField
                  label="Email"
                  type="email"
                  fullWidth
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e?.target?.value)}
                  required
                />
              </Box>
              <Box mb={3}>
                <TextField
                  label="Password"
                  type="password"
                  fullWidth
                  variant="outlined"
                  value={password}
                  onChange={(e) => setPassword(e?.target?.value)}
                  required
                />
              </Box>
              <Button
                type="submit"
                variant="contained"
                // color="primary"
                fullWidth
                size="large"
                style={{
                  textTransform: "none",
                  backgroundColor: "#8C0001",
                  color: "white",
                }}
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </Button>
            </form>
          </Paper>
        </Container>

        {/* Loader Backdrop */}
        <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default Login;
